module.exports = __webpack_public_path__ + "static/media/9DESA15.dc4e4c1a.jpg";